export enum ProfileStatus {
  Approved = 1,
  DeactivatedAndLoggedOut = 5,
  Denied = 10,
  Hidden = 13,
  PendingApproval = 15,
  Incomplete = 20,
}
